import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ynap/button';
import BEMHelper from '@ynap/bem-helper';
import { useContactUs } from '@ynap/contact-us-hook';
import ReactMarkdown from 'markdown-to-jsx';

const bem = new BEMHelper('EmailUsCTA');
const ALLOWED_ELEMENTS = ['p', 'a', 'em'];

const EmailUsCTA = (props) => {
    const {
        messages,
        selectedProduct,
        setUser,
        isSizeAndFit,
        tracking = () => {},
        trackingCallUs = () => {},
        fjwThresholdHandler,
        mrpHandler,
        napHandler,
    } = props;

    const content = useContactUs({ selectedProduct, setUser, isSizeAndFit }) || {};
    const { call = '', isEip = false, personalShopperName = '', sendEmailStructure = {} } = content;

    //all GB and UK (EIPs without dedicated PS and not EIPs/logged out users) will use new free phone numbers, EIPs with PS will keep use the phone number from API
    const email = {
        emailAddress: sendEmailStructure.email,
        subject: encodeURI(sendEmailStructure.subject),
        body: encodeURI(sendEmailStructure.body),
    };
    const phoneNumbers = {
        call: encodeURI(call.replace(/[\s)(]/g, '')),
    };

    const buttonLabel = messages?.emailUsCTA.emailUs({ email: email.emailAddress });
    let emailUsMessages = call ? messages.emailUsCTA.noneEipMessage({ number: call, formattedNumber: phoneNumbers.call }) : '';

    const eipEmailUsMessages = personalShopperName
        ? messages.emailUsCTA.eipWithPSMessage({ name: personalShopperName, number: call, formattedNumber: phoneNumbers.call })
        : messages.emailUsCTA.eipWithoutPSMessage({ number: call, formattedNumber: phoneNumbers.call });
    emailUsMessages = isEip && call ? eipEmailUsMessages : emailUsMessages;

    const anchorOnClick = useCallback(
        (e) => {
            if (e?.target?.href?.startsWith('tel:')) {
                trackingCallUs();
            }
        },
        [trackingCallUs],
    );

    return (
        <div className={bem()}>
            {(mrpHandler || (napHandler && fjwThresholdHandler)) && email.emailAddress && (
                <a href={`mailto:${email.emailAddress}?subject=${email.subject}&body=${email.body}`} className={bem('emailUs-cta')} onClick={tracking}>
                    <Button type="secondary" className="callUs-button">
                        {buttonLabel}
                    </Button>
                </a>
            )}
            {emailUsMessages && (
                <ReactMarkdown
                    className={bem('emailUs-messages')}
                    options={{
                        forceBlock: true,
                        wrapper: 'div',
                        forceWrapper: true,
                        overrides: {
                            em: ({ ...props }) => (
                                <>
                                    <br /> <span>{props.children}</span>
                                </>
                            ),
                            a: {
                                props: {
                                    onClick: anchorOnClick,
                                },
                            },
                        },
                    }}
                >
                    {emailUsMessages}
                </ReactMarkdown>
            )}
        </div>
    );
};

EmailUsCTA.propTypes = {
    messages: PropTypes.shape({
        emailUsCTA: PropTypes.shape({
            emailCTA: PropTypes.func.isRequired,
            callUsEIP: PropTypes.func.isRequired,
            callUs: PropTypes.func.isRequired,
            eipWithPSMessage: PropTypes.func.isRequired,
            eipWithoutPSMessage: PropTypes.func.isRequired,
            noneEipMessage: PropTypes.func.isRequired,
            eipWithPSMessageEmail: PropTypes.func.isRequired,
            eipWithoutPSMessageEmail: PropTypes.func.isRequired,
            noneEipMessageEmail: PropTypes.func.isRequired,
        }).isRequired,
    }),
    setUser: PropTypes.func,
    selectedProduct: PropTypes.isRequired,
    isSizeAndFit: PropTypes.bool,
    tracking: PropTypes.func,
    trackingCallUs: PropTypes.func,
};

export default EmailUsCTA;
